export enum EventFilterType {
	SectorsSubSectors,
	Tags,
	Companies,
	JLABSLocation,
	SavedSearches,
	BlueKnight,
}
